module.exports = __webpack_public_path__ + "static/img/sp19.489676b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/sp19.jpg
// module id = fHqi
// module chunks = 0